import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hometwelve-about',
  templateUrl: './hometwelve-about.component.html',
  styleUrls: ['./hometwelve-about.component.scss']
})
export class HometwelveAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
